import { render, staticRenderFns } from "./navbar-admin.vue?vue&type=template&id=7a10e0e6&scoped=true&"
import script from "./navbar-admin.vue?vue&type=script&lang=js&"
export * from "./navbar-admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a10e0e6",
  null
  
)

export default component.exports